const colors = {
  primary: '#C73B2C', // Primary brick red
  primaryDark: '#A52F22', // Darker red for hover/focus
  primaryLight: '#F8F9FA', // Light background or highlights

  secondary: '#F5C347', // Secondary gold
  secondaryDark: '#C99A2E', // Darker accent of secondary gold
  secondaryLight: '#FFE7A3', // Lighter accent of secondary gold

  tertiary: '#2E5B34', // Tertiary dark forest green
  tertiaryDark: '#254929', // Darker accent of tertiary green
  tertiaryLight: '#9BE87A', // Lighter accent of tertiary green

  white: '#FFFFFF', // Pure white
  black: '#000000', // True black
  ink: '#3A2A1E', // Warm near-black for hero neutral text

  grey: '#6C757D', // Neutral gray (general-purpose)
  greyDark: '#343A40', // Darker shade for hover/focus
  greyLight: '#E9ECEF', // Light background or highlights
  darkGrey: '#666666', // Dark grey for text
  lightGrey: '#F0F0F0', // Light grey for borders/backgrounds

  // Functional Colors
  success: '#28a745', // Success (green)
  error: '#dc3545', // Error (red)
  warning: '#ffc107', // Warning (yellow)
  info: '#17a2b8', // Info (teal-blue)

  yellow: '#F5C347',
  orange: '#F7A43F',
  red: '#C73B2C',
  green: '#2E5B34',
  offWhite: '#F7EFE3',
  offWhiteDark: '#EDE3D2',
  tanLight: '#E6D7BB',
  tanDark: '#D9C6A3',

  // Design System Colors (from ItemManagement)
  amber: {
    500: '#f59e0b',
    600: '#ea580c',
  },
  blue: {
    50: '#eff6ff',
    500: '#3b82f6',
    600: '#2563eb',
  },
  emerald: {
    500: '#10b981',
    600: '#059669',
  },
  redAccent: {
    500: '#ef4444',
    600: '#dc2626',
  },
  purple: {
    500: '#8b5cf6',
  },
  indigo: {
    500: '#6366f1',
  },
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },

  // Admin UI backgrounds
  adminBackground: '#f3f4f6', // Main background for admin sections (gray.100)
  adminControlsBackground: '#f9fafb', // Controls area background (gray.50)
};

export default colors;
